const message = {
    RecentSearch: "Recent Search"
};

export default message;
